import { Controller } from 'stimulus';
import { isUndefined } from 'util';

export default class extends Controller {
  static targets = ['otherWarehouse', 'deliveryWarehouse', 'price', 'toggler', 'deliveryToggler'];

  initialize() {
    this.timeout = null;
  }

  connect() {
    if (this.data.get('collapse-warehouses') !== 'true') {
      this.toggleOtherWarehouses();
      this.toggleDeliveryWarehouses();
    }
  }

  toggleOtherWarehouses() {
    this.otherWarehouseTargets.forEach((warehouse) => {
      warehouse.classList.toggle('is-hidden');
    });

    if (this.targets.find('toggler') && this.togglerTarget) {
      [this.togglerTarget.innerText, this.togglerTarget.dataset.newText] = [
        this.togglerTarget.dataset.newText,
        this.togglerTarget.innerText,
      ];
    }
  }

  toggleDeliveryWarehouses() {
    this.deliveryWarehouseTargets.forEach((warehouse) => {
      warehouse.classList.toggle('is-hidden');
    });

    if (this.targets.find('deliveryToggler') && this.deliveryTogglerTarget) {
      [this.deliveryTogglerTarget.innerText, this.deliveryTogglerTarget.dataset.newText] = [
        this.deliveryTogglerTarget.dataset.newText,
        this.deliveryTogglerTarget.innerText,
      ];
    }
  }

  updatePrice(event) {
    const sourceId = event.currentTarget.dataset.sourceId;
    const sourceType = event.currentTarget.dataset.sourceType;

    let params = {
      quantity: event.currentTarget.value,
      source_id: sourceId,
      source_type: sourceType,
    };

    if (event.currentTarget.dataset.cart) {
      params['cart'] = true;
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      fetch(`${this.data.get('url')}/price?${stringify(params)}`, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((html) => {
          this.priceTargets.forEach((element) => {
            if (element.dataset.sourceId == sourceId && element.dataset.sourceType == sourceType) {
              element.outerHTML = html;
            }
          });
        });
    }, 200);
  }
}
